import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load InvitePage
const InvitePage = lazy(() =>
  import('@/pages/InvitePage').then((m) => ({ default: m.InvitePage }))
);

export const inviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/invite/$token',
  component: InvitePage,
});

// Backward compatibility
export const Route = inviteRoute;
